import React from "react";
import RffGroup from "./RffGroup";

const RffCheckboxGroup = ({
  children,
  rowSpacing = 0.5,
  label,
  title,
  contentSx,
}) => {
  return (
    <RffGroup
      title={title}
      label={label}
      suppressBottomMargin
      contentSx={{ p: 1, ...contentSx }}
      rowSpacing={rowSpacing}
      isGridChild
    >
      {children}
    </RffGroup>
  );
};

export default RffCheckboxGroup;
